import { useState } from 'react';
import AuthShell from './AuthShell';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Label } from '../ui/label';

const ForgotPasswordScreen = ({ api, onNav }) => {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
    } catch {
      // generic response regardless
    } finally {
      setIsLoading(false);
      setDone(true);
    }
  };

  return (
    <AuthShell title="Reset password"
      footer={<button onClick={() => onNav('login')} className="text-primary hover:underline">Back to sign in</button>}>
      {done ? (
        <p className="text-sm text-muted-foreground text-center">
          If an account exists for <span className="text-foreground font-medium">{email}</span>,
          a password reset link is on its way. Check your inbox.
        </p>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <p className="text-sm text-muted-foreground">
            Enter your email and we&rsquo;ll send you a link to reset your password.
          </p>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
          </div>
          <Button type="submit" disabled={isLoading} className="w-full">
            {isLoading ? 'Sending…' : 'Send reset link'}
          </Button>
        </form>
      )}
    </AuthShell>
  );
};

export default ForgotPasswordScreen;
